export var API_URL = 'https://api.hcpts.net/api/v1/'
//export var API_URL = 'http://localhost:8000/api/v1/'
//export var API_URL = "http://0.tcp.ap.ngrok.io:12902/api/v1/";

  //'http://3.39.43.10:8000/'; // FOR DEV

export var DEEP_LINK = '';

export var SUCCESS = 1;
export var FAIL = -1;
export var AUTH_FAIL = -2;
export var EXPIRED_KEY = -3;
export var ID_DUP = -4;
export var EMAIL_DUP = -5;
export var RESIGN = -6;
export var ID_NOT_EXIST = -7;
export var PASSWORD_FAIL = -8;
export var COMMUNITY_COMMENT_DUP = -9;
export var VALID_ERROR = -10;
export var INVALID_MEDIA = -11;
export var BLOCKED_USER = -12;
export var DELETED_CONTENT = -13;

export var FEMALE = '여';
export var MALE = '남';

export var NO_PRICE_DATA = '2147483647';

export var MIN_POINT = 2.9;

export var NORMAL = 'NORMAL';
export var INFLUENCER = 'INFLUENCER';
export var EXPERTISE = 'EXPERTISE';

export var PRODUCT = 'PRODUCT';

export var ESTIMATION = 'ESTIMATION';
export var SEARCH = 'SEARCH';

export var PRODUCT_REVIEW = 'PRODUCT_REVIEW';

export var SHORT = 'SHORT';
export var ENOUGH = 'ENOUGH';
export var OVER = 'OVER';


export const GENDER = [FEMALE, MALE];

export const TERM_CATEGORIES = {
  agreeUsage: 'USAGE',
  agreePrivacy: 'PRIVACY',
  agreePrivacyUsage: 'PRIVACY_USAGE',
  agreeOver14: 'OVER14',
  agreeAd: 'MARKETING',
};

export const getGenderStr = gender => {
  return gender === FEMALE ? '여자' : '남자';
};

export const getGenderStr2 = gender => {
  return gender === FEMALE ? '여성' : '남성';
};

export const convertGenderToVar = gender => {
  return gender === '여성' || gender === '여자' ? FEMALE : MALE;
};

Object.size = function (obj) {
  var size = 0,
    key;
  for (key in obj) {
    if (obj.hasOwnProperty(key)) {
      size++;
    }
  }
  return size;
};

export const storeData = async (key, data) => {
  try {
    await sessionStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    alert(error);
  }
};

export const retrieveData = async key => {
  try {
    return await JSON.parse(sessionStorage.getItem(key));
  } catch (error) {}
};

export const removeData = async key => {
  try {
    await sessionStorage.removeItem(key);
  } catch (error) {}
};


export function range(size, startAt = 0) {
  return [...Array(size).keys()].map(i => i + startAt);
}

export function sendRequest(url, method, body, onSuccess, onError, token) {
  // removeData(['accessToken'])
  retrieveData('accessToken').then(accessToken => {
    // console.log(data.accessToken);
    fetch(API_URL + url, {
      method: method,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization:
          token === null
            ? ''
            : accessToken || token
            ? 'Bearer ' + (token ? token : accessToken)
            : null,
      },
      body:
        ['POST', 'PUT', 'PATCH'].indexOf(method) !== -1
          ? JSON.stringify(body)
          : null,
    })
      .then(response => response.json())
      .then(responseJson => {
        // alert(responseJson.linusCode)
        // console.log(JSON.stringify(responseJson))
        if (responseJson.linusCode === SUCCESS) {
          if (onSuccess) {
            onSuccess(responseJson.data, responseJson.page);
          }
        } else {
          if (onError) {
            onError(responseJson.data, responseJson.linusCode);
          } else {
            console.log(
              (responseJson.data ? responseJson.data.msg : '서버 에러') +
                ' [' +
                responseJson.linusCode +
                '] ' +
                url,
            );
          }
        }
      })
      .catch(error => {
        console.log(error);
      });
  });
}

export function sendFormRequest(url, method, body, onSuccess, onError) {
  if (['POST', 'PUT'].indexOf(method) === -1) {
    alert('Error on method!');
    return;
  }
  retrieveData('accessToken').then(accessToken => {
    fetch(API_URL + url, {
      method: method,
      headers: {
        // Accept: 'application/json',
        // 'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + accessToken,
      },
      body: body,
    })
      .then(response => response.json())
      .then(responseJson => {
        if (responseJson.linusCode === SUCCESS) {
          if (onSuccess) {
            onSuccess(responseJson.data);
          }
        } else {
          if (onError) {
            onError(
              responseJson.data ? responseJson.data : responseJson,
              responseJson.linusCode,
            );
          } else {
            console.log(
              (responseJson.data ? responseJson.data.msg : '서버 에러') +
                ' [' +
                responseJson.linusCode +
                '] ' +
                url,
            );
          }
        }
      })
      .catch(error => {
        console.log(error);
      });
  });
}


export const getTags = inputText => {
  if (!inputText) {
    return [];
  }
  const words = inputText.split(/(\s+)/);
  const formattedText = [];
  words.forEach((word, index) => {
    if (word.startsWith('#')) {
      formattedText.push(word.split('#').pop());
    }
  });
  return formattedText;
};

export const showTags = inputText => {
  if (!inputText) {
    return '';
  }
  const words = inputText.split(/(\s+)/);
  const formattedText = [];
  words.forEach((word, index) => {
    const isLastWord = index === words.length - 1;
    if (word.startsWith('#')) {
      const mention = word;
      isLastWord ? formattedText.push(mention) : formattedText.push(mention);
    } else {
      return isLastWord ? formattedText.push(word) : formattedText.push(word);
    }
  });
  return formattedText;
};

export function fillZero(value) {
  if (value?.toString()?.length >= 2) {
    return value.toString();
  } else {
    return '0' + value;
  }
}

export function getOrderedList(list, key, isReverse = false) {
  if (!list) return list
  list.sort((first, second) => {
    if (!first[key]) {
      return null;
    }
    return compareObjects(first, second, key, isReverse);
  });
  return list;
}

export function compareObjects(object1, object2, key, isReverse) {
  const obj1 = object1[key];
  const obj2 = object2[key];

  if (obj1 < obj2) {
    return isReverse ? -1 : 1;
  }
  if (obj1 > obj2) {
    return isReverse ? 1 : -1;
  }
  return 0;
}

export function isCloseToBottom({
  layoutMeasurement,
  contentOffset,
  contentSize,
}, paddingToBottom=500) {
  // console.log(layoutMeasurement.height + contentOffset.y, contentSize.height - paddingToBottom)
  return (
    layoutMeasurement.height + contentOffset.y >=
    contentSize.height - paddingToBottom
  );
}

export function isTouchBottom({
                                  layoutMeasurement,
                                  contentOffset,
                                  contentSize,
                                }) {
  const paddingToBottom = 10;
  // console.log(layoutMeasurement.height + contentOffset.y, contentSize.height - paddingToBottom)
  return (
    layoutMeasurement.height + contentOffset.y >=
    contentSize.height - paddingToBottom
  );
}

export function intToMinuteSecond(time) {
  return fillZero(parseInt(time / 60)) + ':' + fillZero(parseInt(time % 60));
}

export var KAKAO = '카카오';
export var GOOGLE = '구글';
export var NAVER = '네이버';
export var APPLE = '애플';
export var INSTAGRAM = '인스타그램';

export function getWeekday(day) {
  if (day == 0) {
    return '월';
  }
  if (day == 1) {
    return '화';
  }
  if (day == 2) {
    return '수';
  }
  if (day == 3) {
    return '목';
  }
  if (day == 4) {
    return '금';
  }
  if (day == 5) {
    return '토';
  }
  if (day == 6) {
    return '일';
  }
}

export function getWeekdayFromDay(day) {
  if (day == 0) {
    return '일';
  }
  if (day == 1) {
    return '월';
  }
  if (day == 2) {
    return '화';
  }
  if (day == 3) {
    return '수';
  }
  if (day == 4) {
    return '목';
  }
  if (day == 5) {
    return '금';
  }
  if (day == 6) {
    return '토';
  }
}

export const getDateString = date => {
  return (
    date?.getFullYear() +
    '년 ' +
    fillZero(date?.getMonth() + 1) +
    '월 ' +
    fillZero(date?.getDate()) +
    '일'
  );
};

export function getDateStr(date) {
  return (
    date?.getFullYear() +
    '-' +
    fillZero(date?.getMonth() + 1) +
    '-' +
    fillZero(date?.getDate())
  );
}

export function getDateTimeStr(date) {
  return (
    date?.getFullYear() +
    '.' +
    fillZero(date?.getMonth() + 1) +
    '.' +
    fillZero(date?.getDate()) +
    ' ' +
    fillZero(date?.getHours()) +
    ':' +
    fillZero(date?.getMinutes())
  );
}

export function getDateStrFromObj(date) {
  return (
    date?.getFullYear()?.toString()?.slice(2) +
    '.' +
    fillZero(date?.getMonth() + 1) +
    '.' +
    fillZero(date?.getDate())
  );
}

export function getDateStringFromObj(date) {
  return (
    date?.getFullYear() +
    '.' +
    fillZero(date?.getMonth() + 1) +
    '.' +
    fillZero(date?.getDate())
  );
}

export function getTimeStr(date) {
  return (
    fillZero(date?.getHours()) +
    ':' +
    fillZero(date?.getMinutes())
  );
}

export function getTimeString(date) {
  const hours = date?.getHours()
  const amPm = hours > 12 ? '오후' : '오전'

  return (
    amPm + ' ' +
    fillZero(date?.getHours() - 12) +
    ':' +
    fillZero(date?.getMinutes())
  );
}

export function getTimeAmPmStr(date) {
  const hours = date.hour
  const amPm = hours >= 12 ? '오후' : '오전'

  return (
    amPm + ' ' +
    (date.hour > 12 ? date.hour - 12 : date.hour) +
    ':' +
    fillZero(date.min)
  );
}

export function getMinSec(int) {
  const min = parseInt(int / 60)
  const seconds = int % 60

  return min + ':' + fillZero(seconds)
}

export function getMin(int) {
  const min = parseInt(int / 60)
  return min
}


export function getDateObj(dateObj) {
  return new Date(new Date().getFullYear(), dateObj.month - 1, dateObj.day);
}

export function getCustomObjFromDate(date) {
  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
    weekday: date.getDay(),
  };
}

export function getTodayStrFromObj(date) {
  return (
    '(' +
    (date.getMonth() + 1).toString() +
    '월 ' +
    date.getDate().toString() +
    '일)'
  );
}

export function getTodayStr(date) {
  return (
    (date?.getMonth() + 1) +
    '월 ' +
    (date?.getDate()) +
    '일 ' +
    getWeekdayFromDay(date?.getDay()) +
    '요일'
  );
}

export var gradientColors = [
  [
    'rgba(250, 194, 142, 1)',
    'rgba(255, 138, 174, 1)',
    'rgba(250, 194, 142, 1)',
  ],
  ['rgba(150, 198, 255, 1)', 'rgba(103, 161, 229, 1)'],
  ['rgba(155, 239, 185, 1)', 'rgba(81, 199, 140, 1)'],
];

export function log(data) {
  // console.log(JSON.stringify(data))
}

export function log_(data) {
  // console.log(JSON.stringify(data))
}

export function shuffle(array) {
  let currentIndex = array.length,
    randomIndex;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
}

export const bigHitSlop = {
  top: 35,
  bottom: 35,
  left: 35,
  right: 35,
};

export const hitSlop = {
  top: 15,
  bottom: 15,
  left: 15,
  right: 15,
};

export const smallHitSlop = {
  top: 5,
  bottom: 5,
  left: 5,
  right: 5,
};

export const getImoji = nation => {
  switch (nation) {
    case '국':
      return '🇰🇷';
    case '국내':
      return '🇰🇷';
    case '캐나다':
      return '🇨🇦';
    case '미국':
      return '🇺🇸';
    case '독일':
      return '🇩🇪';
    case '대만':
      return '🇹🇼';
    case '폴란드':
      return '🇵🇱';
    case '호주':
      return '🇦🇺';
    case '슬로베니아':
      return '🇸🇮';
    case '영국':
      return '🇬🇧';
    case '이탈리아':
      return '🇮🇹';
    case '인도':
      return '🇮🇳';
    case '세인트키츠 네비스':
      return '🇰🇳';
    case '네덜란드':
      return '🇳🇱';
    case '노르웨이':
      return '🇳🇴';
    case '스웨덴':
      return '🇸🇪';
    case '뉴질랜드':
      return '🇳🇿';
    case '일본':
      return '🇯🇵';
    case '스위스':
      return '🇨🇭';
    case '중국':
      return '🇨🇳';
    case '덴마크':
      return '🇩🇰';
    case '브라질':
      return '🇧🇷';
    case '멕시코':
      return '🇲🇽';
    case '프랑스':
      return '🇫🇷';
    case '베트남':
      return '🇻🇳';
    case '오스트리아':
      return '🇦🇹';
    case '핀란드':
      return '🇫🇮';
    case '터키':
      return '🇹🇷';
    case '스페인':
      return '🇪🇸';
    case '칠레':
      return '🇨🇱';
    case '인도네시아':
      return '🇮🇩';
    case '태국':
      return '🇹🇭';
    case '오스트레일리아':
      return '🇦🇺';
    default:
      return '';
  }
};

export const idCheck = id => {
  var re = new RegExp(/^(?=.*[a-zA-Z0-9]).{4,}$/);
  return re.test(id);
};

export const passwordCheck = password => {
  if (!password?.length) return true
  var re = new RegExp(
    /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$&()\\-`.+,/\"]{8,20}$/,
  );
  return re.test(password);
};

export function validateEmail(email, setValue=()=>{}) {
  if (!email?.length) return true
  var re =
    /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!re.test(email)) {
    setValue('')
    alert('올바른 이메일 형식으로 입력해 주세요.')
  }
}

export function validatePhone(phone, setValue=()=>{}) {
  if (!phone?.length) return true
  // if (phone?.length > 12) {
  //   alert('휴대폰 번호가 너무 깁니다. 다시 확인해 주세요.')
  //   return
  // }
  var re = /^\d+$/;
  if (!re.test(phone)) {
    setValue('')
    alert('특수문자를 제외한 숫자만 입력해주세요.')
    return false
  }
  return true
}


export const validator = (type, string) => {
  switch (type) {
    case 'password':
    case 'passwordConfirm':
      return passwordCheck(string);
    case 'email':
      return validateEmail(string);
    default:
      return true;
  }
};

export const setImageFormData = image => {
  const formData = new FormData();
  const photo = {
    uri: image?.path
      ? image?.path
      : image?.url
        ? image?.url
        : image?.uri
          ? image?.uri
          : image?.image
            ? image?.image
            : image,
    type: 'image/jpg',
    name: image?.fileName
      ? image?.fileName
      : image?.name
        ? image?.name
        : 'image.jpg',
  };

  formData.append('image', photo);

  return formData;
};

export const setImagesFormData = images => {
  const formData = new FormData();

  for (let idx in images) {
    const photo = images[idx];

    if (photo?.url) {
      continue;
    }

    let image = {
      uri: photo?.path
        ? photo?.path
        : photo?.url
        ? photo?.url
        : photo?.uri
        ? photo?.uri
        : photo?.image
        ? photo?.image
        : photo,
      type: 'image/jpg',
      name: photo?.fileName
        ? photo?.fileName
        : photo?.name
        ? photo?.name
        : 'image.jpg',
    };
    formData.append('images', image);
  }

  return formData;
};

export const getAlarms = alarmProducts => {
  let alarms = [];
  for (let idx in alarmProducts) {
    let alarmProduct = alarmProducts[idx];
    alarms = alarms.concat(alarmProduct.alarms);
  }
  return alarms;
};

String.prototype.hashCode = function () {
  var hash = 0,
    i,
    chr;
  if (this.length === 0) {
    return hash;
  }
  for (i = 0; i < this.length; i++) {
    chr = this.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};

export function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16),
  );
}

export const DAYS = [
  {name: '월', key: 0},
  {name: '화', key: 1},
  {name: '수', key: 2},
  {name: '목', key: 3},
  {name: '금', key: 4},
  {name: '토', key: 5},
  {name: '일', key: 6},
];

export function sameDay(d1, d2) {
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
}

export function checkIfArrayIsUnique(myArray) {
  return myArray.length === new Set(myArray).size;
}

export function numberWithCommas(x) {
  if (!x) {
    return 0;
  }
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function numberWoCommas(x) {
  if (!x) {
    return 0;
  }
  return parseInt(x.toString().replace(/,/g, ""));
}

export function getAge(birthday) {
  if (!birthday) return 0
  var today = new Date();
  var birthDate = new Date(birthday);
  var age = today.getFullYear() - birthDate?.getFullYear();
  var m = today.getMonth() - birthDate?.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate?.getDate()))
  {
    age--;
  }
  return age;
}


export const getCode = (code) => {
  if (!code) return ''
  return code.slice(0, 4) + '-' + code.slice(4, 8) + '-' + code.slice(8, 12) + '-' + code.slice(12, 16)
}


export const dateToString = (str) => {
  if (str === null || str === undefined || str.length === 0) {
    return '';
  }

  const dateFromStr = new Date(str);

  const date = new Date(+dateFromStr + 3240 * 10000)
    .toISOString()
    .split("T")[0];

  const time = dateFromStr.toTimeString().split(" ")[0];

  return `${date} ${time}`;
};

